exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=file][data-v-5cfa27ae]{cursor:pointer}#PreviewTable td[data-v-5cfa27ae],td.border_single[data-v-5cfa27ae]{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5cfa27ae","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Master/Holding/HoldingImportModal.vue
// module id = 963
// module chunks = 0